
import { Card } from "@/components/ui/card";
import { useToolUsage } from "@/hooks/use-tool-usage";

export function StatsPanel() {
  // The hook expects the canvas and activeTool as arguments, but since we're just using it for stats
  // we can pass null here as we only need access to the used tools state
  const { usedTools } = useToolUsage(null, null);
  
  // Calculate stats from usedTools directly
  const stats = {
    shapes: usedTools?.draw ? 1 : 0,
    measurements: (usedTools?.ruler || usedTools?.angle) ? 1 : 0
  };
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Drawing Statistics</h3>
      <Card className="p-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col items-center">
            <span className="text-sm text-muted-foreground">Shapes Created</span>
            <span className="text-2xl font-bold">{stats.shapes}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-sm text-muted-foreground">Measurements</span>
            <span className="text-2xl font-bold">{stats.measurements}</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
